import {
    CLEAR_RESULT_BOT,
    FETCH_RESULT_BOT,
    LIST_RESULT_BOT,
    MODIFY_RESULT_BOT,
    UPDATE_RESULT_BOT_STATUS
} from "./types";

const init = {
    isLoading: false,
    filter: {},
    list: []
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_RESULT_BOT:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_RESULT_BOT:
            return {
                ...state,
                isLoading: false,
                list: payload
            };
        case MODIFY_RESULT_BOT:
        case UPDATE_RESULT_BOT_STATUS:
            return {
                ...state,
                isLoading: true
            };
        case CLEAR_RESULT_BOT:
            return {
                ...init
            };
        default:
            return state;
    }
}
